import React, { useState } from "react";
import axios from "axios";

const Phonepe  = () => {
    const [paymentUrl, setPaymentUrl] = useState("");
    const [merchantOrderId, setMerchantOrderId] = useState("");
    const [paymentStatus, setPaymentStatus] = useState("");
    const [paymentState, setPaymentState] = useState("");
    const getAuthToken = async () => {
        try {
            const response = await axios.post(`${process.env.REACT_APP_API}/payment/get-auth-token`);
            return response.data.access_token;
        } catch (error) {
            console.error("Error fetching auth token:", error);
            return null;
        }
    };

    const generateOrderId = () => {
        const timestamp = Date.now();
        const random = Math.floor(Math.random() * 10000);
        return `ORD_${timestamp}_${random}`.slice(0, 63);
    };

    const initiatePayment = async () => {
        const token = await getAuthToken();
        if (!token) return;

        const generatedOrderId = generateOrderId();
        setMerchantOrderId(generatedOrderId);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API}/payment/initiate-payment`,
                { amount: 1, merchantOrderId: generatedOrderId, token },
                {
                    headers: {
                        Authorization: `O-Bearer ${token}`,
                        "Content-Type": "application/json",
                    },
                }
            );

            setPaymentUrl(response.data.redirectUrl);
            setPaymentState(response.data.state);

            if (response.data.redirectUrl) {
                const tryCheckout = () => {
                    if (window.PhonePeCheckout && window.PhonePeCheckout.transact) {
                        window.PhonePeCheckout.transact({
                            tokenUrl: response.data.redirectUrl,
                            type: "IFRAME",
                            callback: function (result) {
                                // console.log("Payment Result:", result);
                                // You may call verify here if you want
                            }
                        });
                    } else {
                        window.location.href = response.data.redirectUrl;
                    }
                };

                setTimeout(tryCheckout, 500);
            }
        } catch (error) {
            console.error("Payment initiation failed:", error.response?.data || error.message);
        }
    };

    const verifyPayment = async () => {
        const token = await getAuthToken();
        if (!token || !merchantOrderId) return;

        try {
            const response = await axios.post(`${process.env.REACT_APP_API}/payment/verify-payment`, {
                merchantOrderId,
                token,
            });

            const status = response.data?.data?.state || "Unknown";
            setPaymentStatus(status);
        } catch (error) {
            console.error("Error verifying payment:", error);
            setPaymentStatus("Error fetching status");
        }
    };

    return (
        <div>
            
            
            
            <button 
            onClick={initiatePayment}
            class="button">
  <span>P</span>
  <span>A</span>
  <span>Y</span> 
<span> </span>
  <span>N</span>
  <span>O</span>
  <span>W</span>
</button>



        </div>
    );
};

export default Phonepe ;
